import { defineStore } from 'pinia'
import { ref } from 'vue'

import { apiPatios } from '@/services/patio'
import { useAlert } from '@/composables/useAlert'

export const usePatios = defineStore('usePatios', () => {
   const { alertError } = useAlert()
   const { obter } = apiPatios()

   const loadingPatios = ref(false)
   const patios = ref(null)

   const obterPatios = async (params) => {
      try {
         loadingPatios.value = true
         const resposta = await obter(params)
         patios.value = resposta
      } catch (error) {
         return alertError('Não foi possível carregar registro.')
      } finally {
         loadingPatios.value = false
      }
   }
   return {
      loadingPatios,
      patios,
      obterPatios
   }
})
